// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2CBC8","title":"AfterBackImages_title__IGhpN","images":"AfterBackImages_images__1Gdvw"};